import { useEffect, useState } from 'react';
import { X } from 'react-feather';

import { getLanguage, useLanguage } from '@languages/index';

const TrackingNumberGuideModal = (props: any) => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.campaigns };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const closeOverlays = () => {
    if (props.preferences.isMobile) {
      props.closeSheet();
    } else {
      props.closePopup();
    }
  };

  return (
    <div
      className="relative bg-white p-[50px] rounded-lg shadow-md max-h-[80vh] overflow-scroll"
      style={{ width: windowWidth < 480 ? `${windowWidth}px` : '480px' }}
    >
      <div className="flex flex-col">
        <div
          className="absolute right-0 top-0 p-[30px] cursor-pointer"
          onClick={() => {
            closeOverlays();
          }}
        >
          <X strokeWidth={1} />
        </div>
        <div className="flex flex-col gap-[50px]">
          <h2 className="text-[22px] font-bold mb-[30px]">
            {languageTexts._tracking_number_guide_title()}
          </h2>
          <div className="flex flex-col gap-[10px]">
            <span className="font-bold">
              {languageTexts.tracking_number_guide_01}
            </span>
            <span>{languageTexts.tracking_number_guide_02}</span>
            <img
              src={`/assets/images/campaigns/tracking-number-guide-01-${getLanguage()}.png`}
              alt="tracking-number-guide-01"
            />
          </div>
          <div className="flex flex-col gap-[10px]">
            <span className="font-bold">
              {languageTexts.tracking_number_guide_03}
            </span>
            <span>{languageTexts.tracking_number_guide_04}</span>
            <img
              src={`/assets/images/campaigns/tracking-number-guide-02-${getLanguage()}.png`}
              alt="tracking-number-guide-02"
            />
          </div>
          <div className="flex flex-col gap-[10px]">
            <span className="font-bold">
              {languageTexts.tracking_number_guide_05}
            </span>
            <span>{languageTexts.tracking_number_guide_06}</span>
            <img
              src={`/assets/images/campaigns/tracking-number-guide-03-${getLanguage()}.png`}
              alt="tracking-number-guide-03"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrackingNumberGuideModal;
